const apiVersion = 'apis/v1'

export const authUrls = {
  otpSend: `${apiVersion}/accounts/login/otp/send`,
  otpVerify: `${apiVersion}/accounts/login/otp/verify`,
  popupViewed: `${apiVersion}/accounts/login/popup_viewed`,
  login: `${apiVersion}/accounts/login`,
  google: `${apiVersion}/accounts/login/oauth/google`,
  qr: `${apiVersion}/accounts/qr`,
  qrPoll: uuid => `${apiVersion}/accounts/qr/${uuid}`,
  loginQr: `${apiVersion}/accounts/login/qr`,
  logout: `${apiVersion}/accounts/logout`,
  refresh: `${apiVersion}/accounts/refresh`,
  admin: `${apiVersion}/accounts/login/admin`
}

export const userInfoUrls = {
  oauthGoogle: `${apiVersion}/clients/oauth/google`
}

export const clientProfile = {
  profile: `${apiVersion}/clients/profile`,
  settings: `${apiVersion}/clients/profile/settings`,
  avatars: `${apiVersion}/clients/profile/avatars/all`,
  clientAvatar: `${apiVersion}/clients/profile/avatars`
}

export const contactUrls = {
  list: `${apiVersion}/clients/profile/contacts`,
  send: `${apiVersion}/clients/profile/contacts/send`,
  verify: `${apiVersion}/clients/profile/contacts/verify`
}

export const accountUrls = {
  list: `${apiVersion}/accounts`,
  add: `${apiVersion}/accounts`,
  remove: uid => `${apiVersion}/accounts/${uid}`,
  change: `${apiVersion}/accounts/change`
}

export const paymentUrls = {
  payment_methods: `${apiVersion}/payments/types`,
  privat: `${apiVersion}/payments/privatbank`,
  liqpay: `${apiVersion}/payments/liqpay`,
  monobank: `${apiVersion}/payments/monobank`,
  easypay: `${apiVersion}/payments/easypay`,
  platon_invoice: `${apiVersion}/payments/platon_invoice`,
  hutko: `${apiVersion}/payments/hutko`
}

export const tariffUrls = {
  change_tarif: `${apiVersion}/tariffs/change`,
  connect_request: `${apiVersion}/tariffs/internet/requests/10g`,
  realip: `${apiVersion}/services/realip`,
  freeze: `${apiVersion}/services/freeze`,
  internet: `${apiVersion}/tariffs/internet`,
  internet_all: `${apiVersion}/tariffs/internet/all`
}

export const servicesUrls = {
  list: `${apiVersion}/services`
}

export const tvUrls = {
  status: `${apiVersion}/tariffs/television`,
  tariffs_all: `${apiVersion}/tariffs/television/all`,
  channels: tariffId => `${apiVersion}/tariffs/television/${tariffId}/channels`,
  devices: `${apiVersion}/tariffs/television/devices`,
  device: deviceId => `${apiVersion}/tariffs/television/devices/${deviceId}`
}

export const feedbackUrls = {
  index: `${apiVersion}/clients/feedbacks`
}
export const messagesUrls = {
  get_data: `${apiVersion}/notifications`
}

export const bonusesUrls = {
  achievement: `${apiVersion}/clients/bonuses/achievements/all`,
  bonus_balance: `${apiVersion}/clients/bonuses/balance`,
  transfer_bonuses_to_bill: `${apiVersion}/clients/bonuses/balance/transfer`,
  client_achievement: `${apiVersion}/clients/bonuses/achievements`,
  loyalty_program: `${apiVersion}/clients/bonuses/terms`,
  referral_url: `${apiVersion}/clients/bonuses/referral`
}

export const billUrls = {
  index: `${apiVersion}/clients/bill`,
  credit: `${apiVersion}/clients/bill/credit`,
  expire: `${apiVersion}/clients/bill/expire`,
  payments: `${apiVersion}/clients/bill/payments`,
  fees: `${apiVersion}/clients/bill/fees`
}
